<template>
  <!--
  <div class="app flex-row align-items-center"
      :style="{ backgroundImage: 'url(img/background.jpg)' }">
  -->      
  <div class="app app-body flex-row align-items-center">
    <div id="spinner" class="justify-content-center align-items-center"
        :style="{ height: spinnerHeight + 'px', 
          width: spinnerWidth + 'px' }" 
        v-if='procesando'>
      <b-spinner id="spinner-spin" label="Loading...">
      </b-spinner>
    </div>

    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4 login-card">
              <b-card-body>
                <b-form>
                  <h1>{{ title }}</h1>
                  <p class="text-muted">Ingrese su nueva contraseña</p>

                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input 
                      class="form-control" 
                      placeholder="Contraseña" 
                      v-model.trim="$v.password.$model" 
                      :state="passwordValido"
                      :type="showPass ? 'text' : 'password'"
                      @blur.native="validate"
                      @focus.native="$event.target.select()" />

                    <b-button class="show-hide-pass" @click="showHidePass">
                      <i :key="showPassKey" 
                        :class="{ 'fa fa-eye': showPass, 'fa fa-eye-slash': !showPass }"></i>
                    </b-button>

                    <b-form-invalid-feedback 
                      id="passFeedback">
                      {{ passwordInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="confirmedPass"
                      placeholder="Confirme su contraseña"
                      v-model.trim="$v.confirmedPass.$model" 
                      :state="confirmedPassValido"
                      :type="showConfirmedPass ? 'text' : 'password'"
                      @blur.native="validate"
                      @focus.native="$event.target.select()"
                      @keyup.enter.native.prevent="resetPassword" />

                    <b-button class="show-hide-pass" @click="showHideConfirmedPass">
                      <i :key="showConfirmedPassKey" 
                        :class="{ 'fa fa-eye': showConfirmedPass, 'fa fa-eye-slash': !showConfirmedPass }"></i>
                    </b-button>
                    <b-form-invalid-feedback 
                      id="confirmedPassFeedback">
                      {{ confirmedPassInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-input-group>

                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" 
                        class="px-4"
                        @click.prevent="resetPassword">{{ button }}</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!-- <b-button variant="link" class="px-0" @click.prevent="forgot">Olvidé mi contraseña</b-button> -->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown= 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, maxLength, minLength, sameAs } from 'vuelidate/lib/validators';
import { msjAlert } from '../../mixins/msjAlert';

export default {
  name: 'ResetPass',
  mixins: [ 
    msjAlert
  ],
  props: {
    register: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      token: '',
      password: '',
      confirmedPass: '',

      noValidar: true,
      passwordValido: null,
      passwordInvalidoMsj: '',
      confirmedPassValido: null,
      confirmedPassInvalidoMsj: '',

      showPass: false,
      showPassKey: 0,
      showConfirmedPass: false,
      showConfirmedPassKey: 0,
    }
  },
  computed: {
    procesando: {
      get: function () {
        return this.$store.getters['spinnerProcesando/procesando'];
      },
      set: function (newValue) {
      }
    },
    spinnerHeight: {
      get: function () {
        return this.$store.getters['spinnerProcesando/height'];
      },
      set: function (newValue) {
      }
    },
    spinnerWidth: {
      get: function () {
        return this.$store.getters['spinnerProcesando/width'];
      },
      set: function (newValue) {
      }
    },
    title() {
      if (this.register) {
        return 'Ingrese sus Credenciales';
      } else {
        return 'Actualización de Credenciales';
      }
    },
    button() {
      if (this.register) {
        return 'Actualizar';
      } else {
        return 'Restablecer';
      }
    },
  },
  created() {
    if (this.$route.query){
      if (this.$route.query.token){
        this.token = this.$route.query.token;
      }
    }
  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "password" || validarTodos) {
        if (this.$v.password.$error) {
          this.passwordValido = false;
          if (!this.$v.password.required) {
            this.passwordInvalidoMsj = 'Debe ingresar la nueva contraseña.';
          } else if (!this.$v.password.minLength || !this.$v.password.maxLength || !this.$v.password.strongPass) {
            this.passwordInvalidoMsj = 'La contraseña debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
            // this.passwordInvalidoMsj = 'La contraseña debe contener entre 8 y 15 caracteres.';
          }
          /*
          } else if (!this.$v.pass.minLength || !this.$v.pass.maxLength || !this.$v.pass.strongPass) {
            this.passInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
          }
          */
        } else {
          this.passwordValido = null;
          this.passwordInvalidoMsj = '';
        }
      }

      if (campo == "confirmedPass" || validarTodos) {
        if (this.$v.confirmedPass.$error) {
          this.confirmedPassValido = false;
          if (!this.$v.confirmedPass.sameAs) {
            this.confirmedPassInvalidoMsj = 'La contraseña no coincide con su confirmación.';
          }
        } else {
          this.confirmedPassValido = null;
          this.confirmedPassInvalidoMsj = '';
        }
      }

    },
    resetPassword () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
            token: this.token,
            password: this.password
        }

        this.showSpinner();
        this.$store.dispatch('user/resetPassword', params)
          .then(() => {
            this.password = '';
            this.confirmedPass = '';
            this.$v.$reset();
            this.showAlert('La contraseña se actualizó con éxito.', 'info', this.goLogin, 5);
          })
          .catch(error => this.showAlertError(error))
          .finally(() => this.hideSpinner())
      }
    },
    goLogin() {
      this.$router.push({ name: 'Login' });
    },
    showHidePass() {
      this.showPass = !this.showPass;
      this.showPassKey++;
    },
    showHideConfirmedPass() {
      this.showConfirmedPass = !this.showConfirmedPass;
      this.showConfirmedPassKey++;
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      strongPass: function(value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        // const containsSpecial = /[#?!@$%^&*-]/.test(value);
        
        // return containsUppercase && containsLowercase && containsNumber && containsSpecial;
        return containsUppercase & containsLowercase & containsNumber;
      }
      /*
      strongPass(pass) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(pass);
      } 
      */
    },
    confirmedPass: {
      sameAs: sameAs('password')
    },    
  },    
}
</script>

<style>
</style>